import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { FIELD_LABEL, fixHref } from "./pixelFix";

const BTN = "border border-black bg-white px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-widest transition-colors duration-100 hover:bg-black hover:text-white";

function detail(e) {
  const d = e.response?.data?.detail;
  return typeof d === "string" ? d : "Couldn't save the pixel";
}

// One problem line in the badge popup, with "Fix it" (inline edit or a link to the setting).
export function PixelFixItem({ text, fix, tid, onDone, onNavigate }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(fix?.value || "");
  const [saving, setSaving] = useState(false);
  const href = fixHref(fix);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.post("/admin/pixel-check/fix", { where: fix.where, field: fix.field, value, page_id: fix.page_id });
      toast.success(`${FIELD_LABEL[fix.field]} ${value.trim() ? "saved" : "removed"}`);
      setEditing(false);
      onDone?.(r.data);
    } catch (e) {
      toast.error(detail(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <li className="space-y-1" data-testid={tid}>
      <div className="flex items-start gap-2">
        <span className="flex-1">{text}</span>
        {href && !editing && (fix.inline
          ? <button type="button" className={BTN} onClick={() => setEditing(true)} data-testid={`${tid}-fix`}>Fix it</button>
          : <Link to={href} className={BTN} onClick={onNavigate} data-testid={`${tid}-fix`}>Fix it</Link>)}
      </div>
      {editing && (
        <div className="space-y-1.5 border border-black bg-zinc-50 p-2" data-testid={`${tid}-editor`}>
          <label className="block text-[10px] font-bold uppercase tracking-widest">
            {FIELD_LABEL[fix.field]} {fix.where === "main" ? "(main pixels, every page)" : "(this buyer only)"}
          </label>
          <input value={value} autoFocus onChange={(e) => setValue(e.target.value)} placeholder="Leave blank to remove it"
                 onKeyDown={(e) => { if (e.key === "Enter") save(); }}
                 className="w-full border border-black bg-white px-2 py-1 font-mono text-xs" data-testid={`${tid}-input`} />
          <div className="flex items-center gap-2">
            <button type="button" disabled={saving} onClick={save} data-testid={`${tid}-save`}
                    className="border border-black bg-black px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-white disabled:opacity-50">
              {saving ? "Saving…" : "Save"}
            </button>
            <button type="button" className={BTN} onClick={() => setEditing(false)} data-testid={`${tid}-cancel`}>Cancel</button>
            <Link to={href} onClick={onNavigate} className="ml-auto text-[10px] font-bold underline" data-testid={`${tid}-open-setting`}>Open setting</Link>
          </div>
        </div>
      )}
    </li>
  );
}
